import { useMemo } from "react"
import { Tooltip } from "@mui/material"

import { LocalizedStrict } from "../../../../../../../modules/localization/components/AppLocalized"

type EventTooltipProps = Readonly<{
    anchorEl: HTMLElement | null
}>

export function EventTooltip({ anchorEl }: EventTooltipProps) {
    const popperProps = useMemo(() => ({ anchorEl }), [anchorEl])

    return (
        <LocalizedStrict id="create-order-calendar-event-tooltip" attrs={{ title: true }}>
            <Tooltip title="Click to book" open={!!anchorEl?.isConnected} PopperProps={popperProps}>
                <span hidden />
            </Tooltip>
        </LocalizedStrict>
    )
}
